import React from 'react';
import { Moon, Sun, Share2 } from 'lucide-react';
import { useToast } from '../../store/ToastContext';

interface SettingsPreferencesProps {
    theme: 'light' | 'dark';
    toggleTheme: () => void;
}

export const SettingsPreferences: React.FC<SettingsPreferencesProps> = ({
    theme,
    toggleTheme
}) => {
    const { showToast } = useToast();

    const handleShare = async () => {
        const shareData = {
            title: 'Evenly',
            text: 'Check out Evenly, a great app for splitting bills!',
            url: window.location.origin
        };

        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (err: unknown) {
                if (err instanceof Error && err.name !== 'AbortError') {
                    void navigator.clipboard.writeText(shareData.url);
                    showToast('Link copied to clipboard!', 'success');
                }
            }
        } else {
            try {
                await navigator.clipboard.writeText(shareData.url);
                showToast('Link copied to clipboard!', 'success');
            } catch {
                showToast('Failed to copy link', 'error');
            }
        }
    };

    return (
        <div className="space-y-3 pt-2">
            <div className="flex w-full items-center justify-between py-2 text-text-body">
                <div className="flex items-center gap-3">
                    {theme === 'dark' ? <Moon size={18} /> : <Sun size={18} />}
                    <span className="text-sm font-medium">Dark Mode</span>
                </div>
                <button
                    onClick={toggleTheme}
                    aria-label="Toggle Dark Mode"
                    className="relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ring-offset-ring-offset"
                    style={{ backgroundColor: theme === 'dark' ? '#0ea5e9' : '#cbd5e1' }}
                >
                    <span
                        className="inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200"
                        style={{ transform: theme === 'dark' ? 'translateX(1.375rem)' : 'translateX(0.25rem)' }}
                    />
                </button>
            </div>
            <button 
                onClick={handleShare}
                className="flex w-full items-center justify-between py-2 text-text-body hover:text-primary-600"
            >
                <div className="flex items-center gap-3">
                    <Share2 size={18} />
                    <span className="text-sm font-medium">Share App</span>
                </div>
            </button>
        </div>
    );
};
